import { Button, List, Modal, Space, Typography } from "antd";
import {
  ArrowUpOutlined,
  ArrowDownOutlined,
} from "@ant-design/icons";
import { useEffect, useState } from "react";

const { Text } = Typography;

interface ReorderItem {
  id: number;
  name: string;
}

interface ReorderModalProps {
  open: boolean;
  title: string;
  items: ReorderItem[];
  onClose: () => void;
  onSave: (items: { id: number; sortOrder: number }[]) => Promise<void>;
}

const ReorderModal = ({ open, title, items, onClose, onSave }: ReorderModalProps) => {
  const [ordered, setOrdered] = useState<ReorderItem[]>(items);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setOrdered(items);
  }, [items]);

  const moveUp = (index: number) => {
    if (index === 0) return;
    const next = [...ordered];
    [next[index - 1], next[index]] = [next[index], next[index - 1]];
    setOrdered(next);
  };

  const moveDown = (index: number) => {
    if (index === ordered.length - 1) return;
    const next = [...ordered];
    [next[index], next[index + 1]] = [next[index + 1], next[index]];
    setOrdered(next);
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const payload = ordered.map((item, idx) => ({
        id: item.id,
        sortOrder: idx + 1,
      }));
      await onSave(payload);
    } finally {
      setSaving(false);
    }
    onClose();
  };

  return (
    <Modal
      open={open}
      title={title}
      onCancel={onClose}
      onOk={handleSave}
      confirmLoading={saving}
      okText="Guardar orden"
      cancelText="Cancelar"
      width={500}
    >
      <div style={{ maxHeight: 400, overflowY: "auto" }}>
      <List
        dataSource={ordered}
        renderItem={(item, index) => (
          <List.Item
            actions={[
              <Space direction="vertical" size="small">
                <Button
                  type="text"
                  size="small"
                  icon={<ArrowUpOutlined />}
                  disabled={index === 0}
                  onClick={() => moveUp(index)}
                />
                <Button
                  type="text"
                  size="small"
                  icon={<ArrowDownOutlined />}
                  disabled={index === ordered.length - 1}
                  onClick={() => moveDown(index)}
                />
              </Space>,
            ]}
          >
            <Text strong>{index + 1}.</Text>{" "}
            <Text>{item.name}</Text>
          </List.Item>
        )}
      />
      </div>
    </Modal>
  );
};

export default ReorderModal;
